import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CostCenter, CostCenterCreate, CostCenterFilter } from '../data/costCenter';

export function createCostCenterService(client: AxiosInstance) {
  return createCrudService<CostCenter, CostCenterCreate, CostCenterFilter>(
    client,
    '/accounting/CostCenter',
    'id',
  );
}

export type CostCenterService = CrudService<CostCenter, CostCenterCreate, CostCenterFilter>;
